import { render, staticRenderFns } from "./AdaptiveImageNew.vue?vue&type=template&id=70154cf7&"
import script from "./AdaptiveImageNew.vue?vue&type=script&lang=ts&"
export * from "./AdaptiveImageNew.vue?vue&type=script&lang=ts&"
import style0 from "./AdaptiveImageNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports